import {Component} from "react";
import request from "request-promise-native";
import Alert from "react-bootstrap/lib/Alert";
import Form from "react-bootstrap/lib/Form";
import FormGroup from "react-bootstrap/lib/FormGroup";
import InputGroup from "react-bootstrap/lib/InputGroup";
import FormControl from "react-bootstrap/lib/FormControl";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Button from "react-bootstrap/lib/Button";
import React from "react";
import Col from "react-bootstrap/lib/Col";
import ValidatedFormComponent from "./ValidatedFormComponent";
import Modal from 'react-responsive-modal';

const PASSWORD_RESET_ENDPOINT = "https://qibipay.azurewebsites.net/api/ChangePassword";

class PasswordReset extends Component {
    constructor(props) {
        /*
            Props:
             - login
             - params
         */

        super(props);
        this.state = {
            loading: false,
            showSuccessModal: false,
            ridFail: false
        };

        if(this.props.params==null || this.props.params['rid']==null || this.props.params['rid'].length!==64 || !/[0-9a-fA-F]+/.test(this.props.params['rid'])) {
            this.state.ridFail=true;
        }
    }

    async signUp() {
        if(this.passwordRef.validated() && this.repeatPasswordRef.validated()) {
            this.setState({loading: true, errorMessage: null});
            //Req to ms azure

            console.log("RID: "+this.props.params['rid']);

            const options = {
                method: 'POST',
                uri: PASSWORD_RESET_ENDPOINT,
                body: {
                    rid: this.props.params['rid'],
                    password: this.passwordRef.value
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            this.setState({loading: false});

            if(response.statusCode!=200) {
                this.setState({errorMessage:response.body.msg});
                return;
            }

            //Success, show modal
            this.setState({
                showSuccessModal: true
            });
        }
    }

    render() {
        return (
            <div className="auth-wrapper d-flex no-block justify-content-center align-items-center bg-dark">
                <div className="auth-box bg-dark border-top border-secondary">
                    <div id="loginform">

                        <div className="text-center p-t-10 p-b-10">
                            <span className="db" style={{color:'white'}}><h2>Qibaccount PASSWORD RESET</h2></span>
                        </div>

                        <Modal open={this.state.ridFail}
                               onClose={() => {}}
                               showCloseIcon={false}>
                            <h2>Reset password error</h2>
                            <p>Your password reset link does not look quite right!</p>
                            <Button bsStyle="warning" onClick={this.props.login}>Back to login page</Button>
                        </Modal>

                        <Modal open={this.state.showSuccessModal}
                                onClose={() => this.setState({showSuccessModal: false})}>
                            <h2>Password reset success!</h2>
                            <p>You have successfully changed your password!</p>
                            <Button bsStyle="success" onClick={this.props.login}>Proceed to login page</Button>
                        </Modal>

                        <div className="form-horizontal m-t-20" id="loginform">
                            <div className="row p-b-10">
                                <div className="col-12">
                                    <Form horizontal>
                                        <ValidatedFormComponent type="password"
                                                                placeholder="Enter new password"
                                                                onValidate={input => {
                                                                    if(input.length<8) return "Password must be at least 8 characters long!";
                                                                    return null;
                                                                }}
                                                                inputRef={ref => this.passwordRef=ref}
                                        />

                                        <ValidatedFormComponent type="password"
                                                                placeholder="Repeat new password"
                                                                onValidate={input => {
                                                                    if(this.passwordRef.value!==input) return "Passwords must match!";
                                                                    return null;
                                                                }}
                                                                inputRef={ref => this.repeatPasswordRef=ref}
                                        />
                                    </Form>
                                    {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                                        <strong>{this.state.errorMessage}</strong>
                                    </Alert>) : ''}
                                    {this.state.loading ? (<div className="p-t-30">
                                        <ProgressBar  active now={100} bsStyle="success" />;
                                    </div>) : ''}
                                </div>
                            </div>
                            <div className="row border-top border-secondary">
                                <div className="col-12">
                                    <div className="form-group">
                                        <div className="p-t-20">
                                            <Col sm={12} componentClass={Button} disabled={this.state.loading} onClick={this.signUp.bind(this)} bsStyle="primary" className="btn btn-success float-right">
                                                {this.state.loading ? 'Resetting password...' : 'Reset password'}
                                            </Col>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p></p>
                        <div className="separator" style={{
                            textAlign: 'center',
                            color: 'white'
                        }}>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PasswordReset;